import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';

import { IonicVue } from '@ionic/vue';

import VueVirtualScroller from 'vue-virtual-scroller';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';
import '@mdi/font/css/materialdesignicons.min.css'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

/* import global css for the entire app */
import '@/assets/app.css';
import '@/assets/language-flags.css';

//Import theme to be used from appConfig.ts
import { Theme, currentTheme } from '../appConfig';

import './groupby.js';

// Conditionally import the theme based on the current theme value
switch (currentTheme) {
  case Theme.VIRTUALLAUNDRY: {
    import('@/theme/virtuallaundry.css');
    break;
  }
  case Theme.NEWASCO: {
    import('@/theme/newasco.css');
    break;
  }
  case Theme.WASMIJNWAS: {
    import('@/theme/wasmijnwas.css');
    break;
  }
}

/* Import I18n instance */
import I18n from '@/i18n/i18n';
import { useWebportalStore } from './stores/webportal';

import { setupIonicI18n, IonicI18nPlugin } from '@/plugins/ionicI18n';

const app = createApp(App)
  .use(I18n)
  .use(IonicVue, {
    mode: 'md'
  })
  .use(createPinia())
  .use(router)
  .use(VueVirtualScroller)
  .use(IonicI18nPlugin);
  
router.isReady().then(async () => {
  // Setup Ionic i18n for translations in ionic components
  setupIonicI18n();
  
  await useWebportalStore().getWebPortals();
  
  app.mount('#app');
});

router.beforeEach(async (to, from, next) => {
  next();
});

// eslint-disable-next-line
app.config.errorHandler = function (err, _vm, _info) {
  //debugger
  window.console.error(err);
};

// eslint-disable-next-line
window.onerror = function (_message, _source, _lineno, _colno, error) {
  //debugger
  window.console.log(error);
};
window.addEventListener('unhandledrejection', (event) => {
  //debugger
  window.console.error(`Reason: ${event.reason}`);
});